import { DateTime } from 'luxon';
// Ajuste o caminho do package.json conforme necessário
import { version } from '../../../package.json';

export interface IStorageData<T> {
  data: string; // Salva como ISO string
  versao: string;
  dados: T;
}

export default class CStorage {
  private static _handle: Storage; // Tipagem correta para localStorage/sessionStorage

  // Inicializa o handle (pode ser chamado no main.ts ou App.vue)
  public static set handle(value: Storage) {
    CStorage._handle = value;
  }

  public static get handle(): Storage {
    if (!CStorage._handle) {
      // Fallback para localStorage nativo se não definido
      if (typeof localStorage !== 'undefined') return localStorage;
      throw new Error(`Nenhum handle de storage definido para "${this.name}"`);
    }
    return CStorage._handle;
  }

  // --------------------------------------
  // Métodos de Instância
  // --------------------------------------

  public static getItem<T>(pChave: string, pValorPadrao?: T): T {
    return (CStorage.handle.getItem(pChave) as any) || pValorPadrao;
  }
  public static setItem(pChave: string, pValor: any) {
    CStorage.handle.setItem(pChave, pValor);
  }
  public static removeItem(pChave: string) {
    CStorage.handle.removeItem(pChave);
  }

  /**
   * Recupera e faz o parse do JSON, validando a estrutura.
   */
  protected get<T>(pChave: string, pValorPadrao?: T): T | null {
    try {
      const lStrItem = CStorage.handle.getItem(pChave);

      if (!lStrItem) {
        return pValorPadrao || null;
      }

      const lObjArmazenado: IStorageData<T> = JSON.parse(lStrItem);

      // Aqui você poderia validar 'lObjArmazenado.versao' se quisesse limpar cache antigo

      return lObjArmazenado.dados;
    } catch (error) {
      console.warn(`Erro ao ler storage key: ${pChave}`, error);
      CStorage.handle.removeItem(pChave);
      return pValorPadrao || null;
    }
  }

  protected set(pChave: string, pValor: any): void {
    try {
      const lEnvelope: IStorageData<any> = {
        data: DateTime.now().toISO(),
        versao: version,
        dados: pValor,
      };
      CStorage.handle.setItem(pChave, JSON.stringify(lEnvelope));
    } catch (error) {
      console.error(`Erro ao salvar no storage: ${pChave}`, error);
    }
  }
}
